import http from '@/services/http'

export async function acessoGruposRefresh () {
  return http.get('/admin/acessogrupotelarefresh')
}
